import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const DomesticFlightsContainer = styled.div<{ isTablet?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${(props) => (props.isTablet ? '#f8faf9' : '#ffffff')};
  margin-bottom: ${(props) => (props.isTablet ? '32px' : '30px')};
  ${down('md')} {
    background-color: #f8faf9;
    margin-bottom: 32px;
  }
`
export const DomesticFlightsHeader = styled.div<{ isTablet?: boolean }>`
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  display: flex;
  align-items: center;
  color: #000000;
  margin: 0px 0px ${(props) => (props.isTablet ? '16px' : '20px')} 0px;
  ${down('md')} {
    margin: 0px 0px 16px 0px;
  }
`

export const DomesticFlightsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
export const Ul = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* padding: 0px 40px 0px 0px; */
  padding: 0px;
  flex: 0 0 25%;
  margin: 12px 0px;
  li::before {
    content: '•';
    margin-right: 0.5em;
    margin-left: 0.5em;
    font-size: 0.9em;
  }
  li {
    color: #131717;
    font-size: 14px;
  }
`

export const MobileSliderContainer = styled.div`
  width: 100%;
`
